<template>
  <div class="product-add">
    <el-form ref="form" size="small" :model="form" label-width="160px">
      <div class="common-form">分销设置</div>
      <el-form-item label="是否开启推广">
        <el-radio-group v-model="form.enabled">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="tips">开启后，订单完成时给直推推荐人发放推广佣金</div>
      </el-form-item>
      <el-form-item label="推广佣金比例(%)">
        <el-input
          v-model.number="form.commission_rate"
          placeholder="如 5 表示订单实付的 5%"
          class="max-w460"
          type="number"
        />
        <div class="tips">基于订单实付金额计算</div>
      </el-form-item>
      <el-form-item label="分享海报">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('share_poster')">选择图片</el-button>
          <div v-if="share_poster_file_path" class="img">
            <img :src="share_poster_file_path" width="100" height="100" />
          </div>
        </el-row>
        <div class="tips">推广中心将展示该海报图片</div>
      </el-form-item>
      <div class="common-button-wrapper">
        <el-button type="primary" :loading="loading" @click="onSubmit">保存</el-button>
      </div>
    </el-form>
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      :config="{ total: 1, file_type: 'image' }"
      @returnImgs="returnImgsFunc"
    />
  </div>
</template>

<script>
import DistributionApi from '@/api/distribution.js'
import Upload from '@/components/file/Upload'

export default {
  components: {
    Upload
  },
  data() {
    return {
      loading: false,
      isupload: false,
      type: '',
      share_poster_file_path: '',
      form: {
        enabled: 0,
        commission_rate: 0,
        share_poster_id: 0
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    openUpload(e) {
      this.type = e
      this.isupload = true
    },
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.type === 'share_poster') {
          this.form.share_poster_id = e[0].file_id
          this.share_poster_file_path = e[0].file_path
        }
      }
      this.isupload = false
    },
    load() {
      DistributionApi.promoteSettingDetail(true).then(res => {
        const v = res.data.values || {}
        this.form.enabled = v.enabled != null ? Number(v.enabled) : 0
        this.form.commission_rate = v.commission_rate != null ? Number(v.commission_rate) : 0
        this.form.share_poster_id = v.share_poster_id != null ? Number(v.share_poster_id) : 0
        this.share_poster_file_path = v.share_poster_url || ''
      }).catch(() => {})
    },
    onSubmit() {
      const r = Number(this.form.commission_rate)
      if (isNaN(r) || r < 0 || r > 100) {
        this.$message.warning('佣金比例请在 0~100 之间')
        return
      }
      this.loading = true
      DistributionApi.promoteSettingSave(
        {
          enabled: this.form.enabled,
          commission_rate: r,
          share_poster_id: this.form.share_poster_id
        },
        true
      )
        .then(() => {
          this.loading = false
          this.$message.success('保存成功')
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.tips {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
}
.img {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/setting.vue